// src/validations/nameValidation.ts

import * as Yup from 'yup';
import {NAME_FIELD_CONFIG} from '../utils/constantsUtils';

const createNameSchema = (fieldKey: string) => {
  const config = NAME_FIELD_CONFIG[fieldKey];
  if (!config) {
    throw new Error(`Invalid fieldKey: ${fieldKey}`);
  }

  const pattern =
    config.pattern ??
    (config.allowSpaces ? /^[a-zA-Z0-9 ]+$/ : /^[a-zA-Z0-9]+$/);
  const patternMessage =
    config.patternMessage ?? `${config.label} allows only letters and numbers.`;

  return Yup.string()
    .required(`${config.label} is required.`)
    .matches(pattern, patternMessage)
    .min(
      config.min,
      `${config.label} must be at least ${config.min} characters.`,
    )
    .max(
      config.max,
      `${config.label} cannot exceed  ${config.max} characters.`,
    );
};

export const yupNameValidationSchema = Yup.object({
  name: createNameSchema('name'),
  first_name: createNameSchema('first_name'),
  sponsor_name: createNameSchema('sponsor_name'),
  last_name: createNameSchema('last_name'),
  main_contact: createNameSchema('main_contact'),
  title: createNameSchema('title'),
  email_address: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  phone_number: Yup.string()
    .matches(
      /^\(\d{3}\) \d{3}-\d{4}$/,
      'Invalid phone number. Use format (999) 999-9999',
    )
    .required('Phone number is required'),
});

export const trimInBetweenNames = (name: string) => {
  return name.replace(/\s+/g, ' ').trim();
};
